<div class="browser-check" *ngIf="!isSupported">
    <div class="browser-warning">
        <div class="warning-icon">⚠️</div>
        <h2>Browser Not Supported</h2>
        <div class="warning-content">
            <p class="browser-info">
                <strong>Current Browser:</strong> {{ browserResult.browserName | titlecase }} {{
                browserResult.browserVersion }}
            </p>
            <p class="recommendation">{{ browserResult.recommendation }}</p>

            <div *ngIf="browserResult.missingFeatures.length > 0" class="missing-features">
                <h3>Missing Required Features:</h3>
                <ul>
                    <li *ngFor="let feature of browserResult.missingFeatures">{{ feature }}</li>
                </ul>
            </div>

            <div class="supported-browsers">
                <h3>Please upgrade to one of these supported browsers:</h3>
                <div class="browser-grid">
                    <div class="browser-option">
                        <strong>Chrome</strong><br>
                        Version 88 or later<br>
                        <a href="https://www.google.com/chrome/" target="_blank" rel="noopener">Download Chrome</a>
                    </div>
                    <div class="browser-option">
                        <strong>Firefox</strong><br>
                        Version 78 or later<br>
                        <a href="https://www.mozilla.org/firefox/" target="_blank" rel="noopener">Download Firefox</a>
                    </div>
                    <div class="browser-option">
                        <strong>Safari</strong><br>
                        Version 14 or later<br>
                        <span class="note">Update via System Preferences</span>
                    </div>
                    <div class="browser-option">
                        <strong>Edge</strong><br>
                        Version 88 or later<br>
                        <a href="https://www.microsoft.com/edge" target="_blank" rel="noopener">Download Edge</a>
                    </div>
                </div>
            </div>

            <div class="instructions">
                <h3>After updating your browser:</h3>
                <ol>
                    <li>Close all browser windows</li>
                    <li>Restart your browser</li>
                    <li>Return to this page</li>
                </ol>
            </div>

            <button (click)="checkAgain()" class="retry-btn">
                Check Again
            </button>
        </div>
    </div>
</div>